module.exports = __webpack_public_path__ + "img/8.da3da1d0.svg";